import { ReactComponent as PostIcon } from '../assets/post.svg';
import { ReactComponent as ArticleIcon } from '../assets/article.svg';
import { ReactComponent as CommentIcon } from '../assets/comment.svg';
import { ReactComponent as ChatIcon } from '../assets/chat.svg';
import { ReactComponent as VideoIcon } from '../assets/video.svg';
import { ReactComponent as RepostIcon } from '../assets/repost.svg';
import { ReactComponent as AdIcon } from '../assets/ad.svg';
import { ReactComponent as PostIconClear } from '../assets/post-clear.svg';
import { ReactComponent as ArticleIconClear } from '../assets/article-clear.svg';
import { ReactComponent as CommentIconClear } from '../assets/comment-clear.svg';
import { ReactComponent as ChatIconClear } from '../assets/chat-clear.svg';
import { ReactComponent as VideoIconClear } from '../assets/video-clear.svg';
import { ReactComponent as RepostIconClear } from '../assets/repost-clear.svg';
import { ReactComponent as AdIconClear } from '../assets/ad-clear.svg';

export const contentTypesMapping: Record<string, string> = {
  POST: 'Post',
  ARTICLE: 'Media article',
  MESSAGE: 'Chat Message',
  COMMENT: 'Comment',
  VIDEO: 'Video',
  REPOST: 'Repost',
  AD: 'Ad',
};

export const contentTypesClearIconsMapping: Record<string, React.ReactNode> = {
  POST: <PostIconClear />,
  ARTICLE: <ArticleIconClear />,
  MESSAGE: <ChatIconClear />,
  COMMENT: <CommentIconClear />,
  VIDEO: <VideoIconClear />,
  REPOST: <RepostIconClear />,
  AD: <AdIconClear />,
};

export const contentTypesOptions: { value: string; label: string }[] = [
  { value: 'POST', label: contentTypesMapping['POST'] },
  { value: 'ARTICLE', label: contentTypesMapping['ARTICLE'] },
  { value: 'MESSAGE', label: contentTypesMapping['MESSAGE'] },
  { value: 'COMMENT', label: contentTypesMapping['COMMENT'] },
  { value: 'VIDEO', label: contentTypesMapping['VIDEO'] },
  { value: 'REPOST', label: contentTypesMapping['REPOST'] },
  { value: 'AD', label: contentTypesMapping['AD'] },
];

export const contentTypesIconsMapping: Record<string, React.ReactNode> = {
  POST: <PostIcon />,
  ARTICLE: <ArticleIcon />,
  MESSAGE: <ChatIcon />,
  COMMENT: <CommentIcon />,
  VIDEO: <VideoIcon />,
  REPOST: <RepostIcon />,
  AD: <AdIcon />,
};

export const mapAllowedTypesByPlatform: Record<string, string[]> = {
  TELEGRAM: ['POST', 'MESSAGE', 'COMMENT', 'REPOST'],
  TIKTOK: ['REPOST', 'VIDEO', 'COMMENT'],
  TWITTER: ['POST', 'COMMENT', 'REPOST'],
  FACEBOOK: ['POST', 'COMMENT', 'AD', 'REPOST'],
  INSTAGRAM: ['POST', 'VIDEO'],
  THREADS: ['POST', 'VIDEO'],
  YOUTUBE: ['VIDEO'],
  VK: ['POST', 'COMMENT'],
  LINKEDIN: ['POST', 'VIDEO'],
  WEB: ['ARTICLE'],
  OK: ['POST'],
  MAX: ['POST', 'REPOST', 'COMMENT'],
  HUPU: ['POST', 'COMMENT'],
  ZHIHU: ['POST', 'COMMENT'],
  PINCONG: ['POST', 'COMMENT'],
  WEIBO: ['POST', 'COMMENT'],
  DOUYIN: ['POST', 'COMMENT'],
  DARKWEB: ['ARTICLE'],
  BLUESKY: ['POST', 'COMMENT'],
  REDDIT: ['POST', 'COMMENT'],
};

export const availableContentTypes: string[] = [
  "POST",
  "ARTICLE",
  "MESSAGE",
  "COMMENT",
  "VIDEO",
  "REPOST",
  "AD",
];

export const canCollectComments = (
  contentTypes: string[] = [],
  platforms: string[] = [],
): boolean =>
  contentTypes?.includes('POST') ||
  (contentTypes?.includes('VIDEO') && platforms?.includes('TIKTOK'));
